// Kiểm 1 path có nằm TRONG (hoặc trùng) 1 thư mục gốc không — cross-platform.
//
// v3.19.3 FIX: các call site cũ so prefix bằng `${resolve(parent)}/` — hardcode
// separator POSIX. Hai chế độ hỏng:
//   - Windows: `path.resolve` trả separator `\` (vd `C:\ws\a`) nên KHÔNG BAO GIỜ
//     khớp prefix `C:\ws/` → guard chặn oan 100% path hợp lệ (avatar init không
//     chạy nổi trên Win, settings hook path bị reject sạch).
//   - POSIX với parent là root `/`: prefix thành `//` → `/ten-ws` trượt → chặn oan.
//
// Dùng path.relative thay vì so chuỗi prefix:
//   rel === ""            → trùng đúng parent
//   rel absolute          → khác drive (Windows `C:` vs `D:`) → ngoài
//   rel === ".." | "../…" → escape ra ngoài parent
//
// Tham số `p` (mặc định = node:path của host) cho phép test CẢ win32 lẫn posix
// trên cùng một máy — nếu không thì hành vi Windows không thể test trên CI macOS.
import nodePath from "node:path";

/** Tập con API của node:path mà helper cần — `path.win32` / `path.posix` đều thoả. */
export type PathImpl = Pick<typeof nodePath, "relative" | "resolve" | "isAbsolute" | "sep">;

/**
 * true khi `child` nằm bên trong `parent`, HOẶC chính là `parent`.
 *
 * Giữ nguyên ngữ nghĩa "inside hoặc same" của 2 call site cũ (init workspace path
 * guard + settings command path guard) — bản vá này CHỈ sửa lỗi separator, không
 * đổi biên an toàn.
 */
export function isPathInsideOrSameDirectory(
  parent: string,
  child: string,
  p: PathImpl = nodePath,
): boolean {
  const rel = p.relative(p.resolve(parent), p.resolve(child));
  if (rel === "") return true;
  if (p.isAbsolute(rel)) return false;
  return rel !== ".." && !rel.startsWith(`..${p.sep}`);
}
